/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/theclub/"

const THE_CLUB: CommunityData = {
  code: "theclub",
  inviteCode: "theclub",
  name: "THE CLUB",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "SEK",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/clu-080`,
  waitlist: false,
  socials: {},
  styles: {
    global: {
      counterColor: "#2289f4",
      werzLogoColor: "#FFFFFF",
      logo: {
        src: `${S3_PREFIX}web-logo-v3.jpg`,
        styles: "w-[160px] h-[41px]",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[160px] h-[41px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#000000",
      asideBg: "#2289f4",
      asideStyles: "!p-0 !gap-0 ",
      contentBg: "#000000",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background-v3.jpg`,
      bgMobile: `${S3_PREFIX}web-background-v3.jpg`,
      nonMemberBg: `${S3_PREFIX}web-background-v3.jpg`,
      mainFont: "font-['NeueHaasGroteskDisplayPro55Roman']",
      primaryButton:
        "bg-[#2289f4] border border-[#2289f4] px-[18px] py-[18px] !text-[#000000] font-['TheClubFont1Regular'] !text-[22px] text-left",
    },
    navigation: {
      iconsColor: "#000000",
      sideBarSeparator: "border-r-[1px] border-[#2289f4]",
      separator: "border-[#2289f4]",
      item: "font-['TheClubFont1Regular'] text-[20px] text-[#000000] text-center  !pl-0 !py-0 text-opacity-50",
      itemSelected: " !text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#000000] !pb-8",
      titles:
        "text-[#2289f4] font-['NeueHaasGroteskDisplayPro65Medium'] text-[28px] text-left leading-[110%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#2289f4] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] text-left leading-[120%]",
      announcementsV2: {
        sectionContainer:
          "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-solid border-[#2289f4]",
        sectionTitle:
          "text-[#2289f4] font-['NeueHaasGroteskDisplayPro65Medium'] text-[28px] text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#000000]",
          mediaContainer: "w-full sm:w-[256px] relative overflow-hidden",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title:
            "text-[#2289f4] font-['NeueHaasGroteskDisplayPro65Medium'] text-[20px] text-left leading-[110%]",
          subtitle:
            "text-[#2289f4] font-['NeueHaasGroteskDisplayPro55Roman'] text-[14px] text-left leading-[120%] mt-2 hidden",
        },
      },
      eventsV2: {
        sectionContainer:
          "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-solid border-[#2289f4]",
        sectionTitle:
          "text-[#2289f4] font-['NeueHaasGroteskDisplayPro65Medium'] text-[28px] text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#000000]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative overflow-hidden",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full !aspect-video bg-gray-400",
          content: "flex flex-col px-0 sm:px-4 py-4 sm:!py-0 bg-transparent",
          title:
            "text-[#2289f4] font-['NeueHaasGroteskDisplayPro65Medium'] text-[16px] text-left leading-[110%]",
          subtitle:
            "text-[#2289f4] font-['NeueHaasGroteskDisplayPro55Roman'] text-[13px] text-left leading-[120%] mt-2",
          location:
            "text-[#2289f4] font-['NeueHaasGroteskDisplayPro55Roman'] text-[13px] text-left leading-[120%] mt-1",
          date: "text-[#2289f4] font-['NeueHaasGroteskDisplayPro55Roman'] text-[13px] text-left leading-[120%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title:
          "text-[#2289f4] font-['NeueHaasGroteskDisplayPro65Medium'] text-[24px] text-left leading-[110%]",
        text: "text-[#2289f4] font-['NeueHaasGroteskDisplayPro55Roman'] text-[17px] text-left leading-[120%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#2289f4] font-['NeueHaasGroteskDisplayPro65Medium'] text-[28px] text-left leading-[110%] !mb-4 sm:mb-6",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#000000] !pb-8",
      eventInfo: {
        container:
          "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-solid border-[#2289f4]",
        media: "sm:!w-[320px] !w-full sm:!h-[180px] !h-[180px] object-cover sm:mb-4 !border-0",
        title:
          "text-[#2289f4] font-['NeueHaasGroteskDisplayPro65Medium'] text-[28px] text-left leading-[110%]",
        subtitle:
          "text-[#2289f4] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] text-left leading-[120%] mb-4 mt-2",
        button:
          "bg-[#2289f4] border border-[#2289f4] px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 gap-y-[6px] text-[#000000] font-['TheClubFont1Regular'] !text-[22px] text-left leading-[100%]",
        questions: "text-[15px] text-left leading-[120%] text-[#2289f4]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-solid border-[#2289f4]",
        header:
          "text-[#2289f4] font-['NeueHaasGroteskDisplayPro65Medium'] text-[24px] text-left leading-[110%]",
        text: "text-[#2289f4] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-solid border-[#2289f4]",
        header:
          "text-[#2289f4] font-['NeueHaasGroteskDisplayPro65Medium'] text-[24px] text-left leading-[110%]",
        text: "text-[#2289f4] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden gap-y-[10px]",
        mapPinColor: "#2289f4",
        mapStrokeColor: "#2289f400",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#2289f4] font-['NeueHaasGroteskDisplayPro65Medium'] text-[24px] text-left leading-[110%]",
        text: "text-[#2289f4] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#2289f4] font-['NeueHaasGroteskDisplayPro65Medium'] text-[24px] text-left leading-[110%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#000000] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#000000] border border-[#2289f4] px-[12px] py-[12px] text-[#2289f4] font-['NeueHaasGroteskDisplayPro65Medium'] text-[15px] text-left leading-[100%] !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#ffffff00] border-b border-[#2289f4] py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#2289f4] font-['NeueHaasGroteskDisplayPro65Medium'] text-[16px] text-left leading-[110%] mb-1",
          description:
            "text-[#2289f4] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] text-left leading-[120%] mb-1 flex flex-row",
          price:
            "text-[#2289f4] font-['NeueHaasGroteskDisplayPro65Medium'] text-[16px] text-left leading-[110%]",
          quantity:
            "text-[#2289f4] font-['NeueHaasGroteskDisplayPro65Medium'] text-[15px] text-left leading-[100%]",
          status:
            "text-[#2289f4] font-['NeueHaasGroteskDisplayPro65Medium'] text-[16px] text-left leading-[110%]",
          counterContainer:
            "bg-[#000000] border border-[#2289f4] px-[12px] py-[12px] gap-x-[16px] !w-fit !h-10",
          button:
            "bg-[#000000] border border-[#2289f4] px-[12px] py-[12px] text-[#2289f4] font-['NeueHaasGroteskDisplayPro65Medium'] text-[15px] text-left leading-[100%] !w-fit",
          plusMinusColor: "#2289f4",
        },
      },
    },
    linktree: {
      bgDesktop: `${S3_PREFIX}web-background-v3.jpg`,
      bgMobile: `${S3_PREFIX}web-background-v3.jpg`,
      bgColor: "#000000",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative bg-[#000000] p-[64px]",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[2.5px] border-[#2289f4]",
        name: "text-[28px] mt-2 text-[#2289f4] font-['NeueHaasGroteskDisplayPro65Medium'] leading-[110%]",
        location: "text-[18px] text-[#2289f4] font-['NeueHaasGroteskDisplayPro65Medium'] mb-2",
        description:
          "text-[17px] leading-[120%] text-[#2289f4] text-center mb-4 font-['NeueHaasGroteskDisplayPro55Roman']",
        socialMediaIconColor: "#2289f4",
        button:
          "flex justify-center items-center bg-[#000000] border border-[#2289f4] px-[12px] py-[12px] text-[#2289f4] font-['NeueHaasGroteskDisplayPro65Medium'] text-[15px] leading-[100%] cursor-pointer",
      },
      upcomingEvents: {
        header:
          "text-[18px] mb-[10px] text-center text-[#2289f4] font-['NeueHaasGroteskDisplayPro65Medium'] leading-[110%]",
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        loadingState:
          "mb-[32px] bg-[#000000] font-['NeueHaasGroteskDisplayPro55Roman'] text-[#2289f4] text-[17px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center border border-[#2289f4]",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] bg-[#000000] flex flex-col justify-center items-center border border-[#2289f4] p-[34px] mb-[32px]",
          title:
            "text-[#2289f4] text-[18px] mb-1 font-['NeueHaasGroteskDisplayPro65Medium'] leading-[110%]",
          text: "text-[17px] text-[#2289f4] font-['NeueHaasGroteskDisplayPro55Roman'] leading-[120%]",
          button:
            "flex justify-center items-center mt-4 bg-[#000000] text-[#2289f4] text-[15px] px-[12px] py-[12px] border border-[#2289f4] font-['NeueHaasGroteskDisplayPro65Medium'] cursor-pointer",
        },
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] bg-[#000000] w-[95vw] flex justify-between border border-[#2289f4]",
          duration:
            "text-[13px] text-[#2289f4] font-['NeueHaasGroteskDisplayPro55Roman'] leading-[120%]",
          name: "text-[18px] leading-[110%] text-[#2289f4] one-line-truncate sm:w-[390px] w-[65vw] font-['NeueHaasGroteskDisplayPro65Medium']",
          plusIconColor: "#2289f4",
          media: "border border-[#2289f4] overflow-hidden m-2",
        },
        event: {
          container: "border border-[#2289f4] bg-[#000000] overflow-hidden sm:w-[500px] w-[95vw]",
          name: "text-[18px] mb-1 text-[#2289f4] font-['NeueHaasGroteskDisplayPro65Medium'] one-line-truncate sm:w-[370px] w-[60vw] leading-[110%]",
          startDate:
            "w-[64px] h-[64px] bg-[#2289f4] text-[#000000] flex flex-col justify-center items-center gap-1 font-['NeueHaasGroteskDisplayPro65Medium']",
          duration:
            "text-[13px] text-[#2289f4] font-['NeueHaasGroteskDisplayPro55Roman'] leading-[120%]",
          location:
            "text-[13px] text-[#2289f4] font-['NeueHaasGroteskDisplayPro55Roman'] leading-[120%]",
          button:
            "flex justify-center items-center mt-3 bg-[#000000] text-[#2289f4] text-[15px] px-[12px] py-[12px] border border-[#2289f4] font-['NeueHaasGroteskDisplayPro65Medium'] cursor-pointer",
          product: {
            container: "h-[68px] border-t border-[#2289f4] px-4 py-3 flex justify-between",
            name: "text-[16px] text-[#2289f4] font-['NeueHaasGroteskDisplayPro65Medium'] one-line-truncate sm:w-[390px] w-[65vw] leading-[110%]",
            price:
              "text-[#2289f4] text-[16px] font-['NeueHaasGroteskDisplayPro65Medium'] leading-[110%]",
            link: "text-[#2289f4] text-[13px] font-['NeueHaasGroteskDisplayPro55Roman']",
            status:
              "text-[#2289f4] text-[16px] font-['NeueHaasGroteskDisplayPro65Medium'] leading-[110%]",
            button:
              "flex justify-center items-center bg-[#000000] text-[#2289f4] text-[15px] px-[12px] py-[8px] border border-[#2289f4] font-['NeueHaasGroteskDisplayPro65Medium'] cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#2289f4] text-[17px] font-['NeueHaasGroteskDisplayPro55Roman'] text-center mt-4 cursor-pointer mb-[32px]",
      },
      news: {
        loadingState:
          "mb-[32px] bg-[#000000] font-['NeueHaasGroteskDisplayPro55Roman'] text-[#2289f4] text-[17px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center border border-[#2289f4]",
        header:
          "text-[18px] mb-[10px] text-center text-[#2289f4] font-['NeueHaasGroteskDisplayPro65Medium'] leading-[110%]",
        container: "flex flex-col gap-4",
        oneNews: {
          container:
            "h-[64px] cursor-pointer bg-[#000000] sm:w-[500px] w-[95vw] flex justify-between border border-[#2289f4]",
          name: "text-[18px] leading-[110%] text-[#2289f4] one-line-truncate sm:w-[390px] w-[65vw] font-['NeueHaasGroteskDisplayPro65Medium']",
          triangleIconColor: "#2289f4",
          created:
            "text-[#2289f4] text-[15px] font-['NeueHaasGroteskDisplayPro55Roman'] leading-[120%]",
          media: "border border-[#2289f4] overflow-hidden m-2",
        },
        seeAllNews:
          "text-[#2289f4] text-[17px] font-['NeueHaasGroteskDisplayPro55Roman'] text-center mt-4 cursor-pointer mb-[32px]",
      },
      radioTracks: {
        header:
          "text-[18px] mb-[10px] text-center text-[#2289f4] font-['NeueHaasGroteskDisplayPro65Medium'] leading-[110%]",
        container: "flex flex-col gap-4",
        loadingState:
          "mb-[32px] bg-[#000000] font-['NeueHaasGroteskDisplayPro55Roman'] text-[#2289f4] text-[17px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center border border-[#2289f4]",
        radioTrack: {
          container:
            "h-[64px] cursor-pointer bg-[#000000] sm:w-[500px] w-[95vw] flex justify-between border border-[#2289f4]",
          title:
            "text-[18px] leading-[110%] text-[#2289f4] one-line-truncate sm:w-[390px] w-[65vw] font-['NeueHaasGroteskDisplayPro65Medium']",
          duration:
            "text-[#2289f4] text-[15px] font-['NeueHaasGroteskDisplayPro55Roman'] leading-[120%]",
          liveType: "text-[#2289f4] text-[13px] font-['NeueHaasGroteskDisplayPro55Roman']",
          liveTypeCircle: "#2289f4",
          playIconColor: "#000000",
          playIconBackgroundColor: "#2289f4",
          playIconBorderColor: "#2289f4",
          start:
            "text-[#2289f4] text-[15px] font-['NeueHaasGroteskDisplayPro55Roman'] leading-[120%]",
          coverUrl: "border border-[#2289f4] overflow-hidden m-2",
        },
        seeAllTracks:
          "text-[#2289f4] text-[17px] font-['NeueHaasGroteskDisplayPro55Roman'] text-center mt-4 cursor-pointer mb-[32px]",
      },
      otherLinks: {
        loadingState:
          "mb-[32px] bg-[#000000] font-['NeueHaasGroteskDisplayPro55Roman'] text-[#2289f4] text-[17px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center border border-[#2289f4]",
        header:
          "text-[18px] mb-[10px] text-center text-[#2289f4] font-['NeueHaasGroteskDisplayPro65Medium'] leading-[110%]",
        container: "flex flex-col gap-[10px] mb-[40px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] bg-[#000000] w-[95vw] flex justify-between border border-[#2289f4]",
          name: "text-[18px] text-[#2289f4] font-['NeueHaasGroteskDisplayPro65Medium'] leading-[110%]",
          triangleIconColor: "#2289f4",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full border border-[#2289f4] object-cover",
        },
      },
      footer: {
        WERZlogoColor: "#FFFFFF",
        text: "",
      },
    },
  },
}

export default THE_CLUB
